module.exports = __webpack_public_path__ + "media/images/delivery-976267123aac0cf108107a1665ac69f0.png";